import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";

/**
 * Confirms cancelling a running batch, with two ways to do it:
 * - drain: companies with a running task finish and get their sheet; nothing new starts.
 * - now: stops the batch's Fargate tasks, so a company mid-classification is killed
 *   partway and gets no sheet. Not undoable — spell that out rather than asking a bare
 *   "are you sure?".
 * Once a drain is under way only "now" is offered, to stop the rest early.
 *
 * @param {{ onConfirm: (mode: "drain" | "now") => void, draining: boolean }} props
 */
function CancelRunDialog({ open, onClose, onConfirm, batchRunId, companyCount, draining }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{draining ? "Stop the remaining tasks?" : "Cancel pipeline run?"}</DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 2 }} />
        {!draining && (
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Finish running tasks</strong> lets companies whose classification has
            already started finish and get their sheet. Companies that haven&apos;t started
            are skipped, and failed companies aren&apos;t retried. This can take a few hours.
          </Typography>
        )}
        <Typography variant="body1">
          <strong>Stop everything now</strong> stops the running geocoder and auto4client
          tasks for this batch. Companies part-way through classification are killed and
          will not get a sheet — data already written to the database stays, but is
          incomplete for those companies.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
          {companyCount} {companyCount === 1 ? "company" : "companies"} in this batch.
        </Typography>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: "text.secondary", wordBreak: "break-all" }}
        >
          {batchRunId}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Keep running</Button>
        {!draining && (
          <Button color="warning" onClick={() => onConfirm("drain")}>
            Finish running tasks
          </Button>
        )}
        <Button color="error" onClick={() => onConfirm("now")}>
          Stop everything now
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelRunDialog;
